import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { createBrowserHistory } from 'history';
import { app_placeholder } from '../env.placeholders';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
  autoCapture: true,
};
console.log('appInsight', app_placeholder.VITE_APP_INSIGHT_CONNECTION_STRING);

// Vérifier si la connection string est fournie
const connectionString = app_placeholder.VITE_APP_INSIGHT_CONNECTION_STRING;

let appInsights = null;
 
if (connectionString && connectionString.trim() !== '') {
  // Créer l'instance seulement si la connection string est valide
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      enableAutoRouteTracking: true,
      extensions: [reactPlugin, clickPluginInstance],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
        [clickPluginInstance.identifier]: clickPluginConfig,
      },
      maxBatchInterval: 15000, // Intervalle maximum entre les envois de lots (en millisecondes)
      maxBatchSizeInBytes: 1000000, // Taille maximale du lot (en octets)
      samplingPercentage: 25
    },
  });
 
  appInsights.loadAppInsights();
  console.log('Application Insights initialized successfully');
} else {
  console.warn('Application Insights connection string not provided - Analytics disabled');
  // Créer un mock pour éviter les erreurs
  appInsights = {
    loadAppInsights: () => {},
    trackEvent: () => {},
    trackPageView: () => {},
    trackException: () => {},
    trackTrace: () => {},
    flush: () => {},
  };
}

export { reactPlugin, appInsights };
